import { Input as UiInput, Radio as UiRadio } from "@rumbledirect/ui";
import { QuestionRadiogroupModel } from "survey-core";
import { useMemo } from "react";
import { createStyles } from "antd-style";

const styleUtils = createStyles(({ css }) => ({
  radioGroup: css`
        input[type="radio"] {
          position: absolute !important;
          height: 1px !important;
          opacity: 0 !important;
        }
    `,
}));

export const RadioQuestion = (props: { question: QuestionRadiogroupModel }) => {
  const { styles } = styleUtils();
  const question = props.question;

  const options = useMemo(
    () =>
      question.visibleChoices.map((c: any) => ({
        value: c.value,
        label: c.text,
      })),
    [question.visibleChoices],
  );

  const onRadioChange = (e: any) => {
    question.value = e.target.value;
  };

  const onOtherInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    question.comment = e.target.value;
  };

  const isOtherSelected = question.isOtherSelected;
  const showOtherItem = question.showOtherItem;
  const orientation = question.getPropertyValue("orientation") || "vertical";
  const isVertical = orientation === "vertical";

  return (
    <UiRadio.Group
      id={question.inputId}
      value={question.value}
      disabled={question.isDisabledAttr || question.isReadOnly}
      onChange={onRadioChange}
      vertical={isVertical}
      aria-required={question.a11y_input_ariaRequired}
      aria-label={question.a11y_input_ariaLabel}
      aria-labelledby={question.a11y_input_ariaLabelledBy}
      aria-describedby={question.a11y_input_ariaDescribedBy}
      aria-invalid={question.a11y_input_ariaInvalid}
      aria-errormessage={question.a11y_input_ariaErrormessage}
      className={styles.radioGroup}
    >
      {options.map((option) => (
        <UiRadio key={option.value} value={option.value}>
          {option.label}
        </UiRadio>
      ))}
      {showOtherItem && isOtherSelected && (
        <UiInput
          styles={{
            root: { fontWeight: 500, marginTop: 8 },
            input: {
              height: "var(--ant-control-height, 48px)",
              padding: "0 16px",
              boxSizing: "border-box",
            },
          }}
          value={question.comment}
          onChange={onOtherInputChange}
          placeholder={question.otherPlaceholder}
          disabled={question.isDisabledAttr}
          aria-label={question.otherText}
        />
      )}
    </UiRadio.Group>
  );
};
